import React, { createRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './style.module.css';
import { LocalData } from "../../service/localStorage";
import { useTranslation } from 'react-i18next';
import DropDown from '../../design-system/lib/DropDown';
import Book from '../../assets/Book.svg';
import Typography from '../../design-system/lib/Typography';
import { showArticle } from '@intercom/messenger-js-sdk';
import { isBoolean } from 'lodash';

export const LearnMore = ({placement , where="test" ,hastext , className ,itemRowClassName}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const localData = new LocalData();
    const [from, setFrom] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [mapZindex, setMapZindex] = useState(null);
    const intercomData = useSelector((state) => state.SharedData.settings?.intercomData)


    let articles ={
        OndemandOrderList: [
          {
            title: 'Order types and statuses',
            link: 'https://help.onro.io/en/articles/10264368-order-types-and-statuses'
          },
          {
            title: 'ETA & delay management',
            link: 'https://help.onro.io/en/articles/10293937-eta-delay-management'
          },
          {
            title: 'How to monitor orders',
            link: 'https://help.onro.io/en/articles/10351129-how-to-monitor-orders'
          },
          {
            title: 'How driver selection works in dispatch algorithm',
            link: 'https://help.onro.io/en/articles/10293802-how-driver-selection-works-in-the-dispatch-algorithm'
          },
          {
            title: 'How dispatching works for scheduled orders',
            link: 'https://help.onro.io/en/articles/10293944-how-dispatching-works-for-scheduled-orders'
          },
          {
            title: 'How to dispatch an order urgently',
            link: 'https://help.onro.io/en/articles/10293819-how-to-dispatch-an-order-urgently'
          }
        ],
        PickupDeliveryOrderList: [
          {
            title: 'How to add orders to a route',
            link: 'https://help.onro.io/en/articles/10441220-how-to-add-orders-to-a-route'
          },
          {
            title: 'Order types and statuses',
            link: 'https://help.onro.io/en/articles/10264368-order-types-and-statuses'
          },
          {
            title: 'P&D workflow basics',
            link: 'https://help.onro.io/en/articles/10264423-p-d-workflow-basics'
          },
          {
            title: 'How to update P&D order status',
            link: 'https://help.onro.io/en/articles/10259538-how-to-update-p-d-order-status'
          },
          {
            title: 'How to manage failed reasons',
            link: 'https://help.onro.io/en/articles/10351131-how-to-manage-failed-reasons'
          },
          {
            title: 'How to monitor orders',
            link: 'https://help.onro.io/en/articles/10351129-how-to-monitor-orders'
          },

          {
            title: 'How to delete an order from a route',
            link: 'https://help.onro.io/en/articles/10272323-how-to-delete-an-order-from-a-route'
          },
         
        ],
        PickupOrderList: [
          {
            title: 'Order types and statuses',
            link: 'https://help.onro.io/en/articles/10264368-order-types-and-statuses'
          },
          {
            title: 'ETA & delay management',
            link: 'https://help.onro.io/en/articles/10293937-eta-delay-management'
          },
          {
            title: 'How to monitor orders',
            link: 'https://help.onro.io/en/articles/10351129-how-to-monitor-orders'
          },
          {
            title: 'How driver selection works in dispatch algorithm',
            link: 'https://help.onro.io/en/articles/10293802-how-driver-selection-works-in-the-dispatch-algorithm'
          },
          {
            title: 'How dispatching works for scheduled orders',
            link: 'https://help.onro.io/en/articles/10293944-how-dispatching-works-for-scheduled-orders'
          },
          {
            title: 'How to dispatch an order urgently',
            link: 'https://help.onro.io/en/articles/10293819-how-to-dispatch-an-order-urgently'
          }
        ],
        DeliveryOrderList: [
          {
            title: 'Order types and statuses',
            link: 'https://help.onro.io/en/articles/10264368-order-types-and-statuses'
          },
          {
            title: 'ETA & delay management',
            link: 'https://help.onro.io/en/articles/10293937-eta-delay-management'
          },
          {
            title: 'How to monitor orders',
            link: 'https://help.onro.io/en/articles/10351129-how-to-monitor-orders'
          },
          {
            title: 'How driver selection works in dispatch algorithm',
            link: 'https://help.onro.io/en/articles/10293802-how-driver-selection-works-in-the-dispatch-algorithm'
          },
          {
            title: 'How dispatching works for scheduled orders',
            link: 'https://help.onro.io/en/articles/10293944-how-dispatching-works-for-scheduled-orders'
          },
          {
            title: 'How to dispatch an order urgently',
            link: 'https://help.onro.io/en/articles/10293819-how-to-dispatch-an-order-urgently'
          }
        ],
        Routes: [
          {
            title: 'How to manage routes',
            link: 'https://help.onro.io/en/articles/10351133-how-to-manage-routes'
          }
        ],
        RouteDetails: [
          {
            title: 'How to delete an order from a route',
            link: 'https://help.onro.io/en/articles/10272323-how-to-delete-an-order-from-a-route'
          },
          {
            title: 'How to complete a route',
            link: 'https://help.onro.io/en/articles/10264619-how-to-complete-a-route'
          },
          {
            title: "How to change an order's route",
            link: 'https://help.onro.io/en/articles/10264648-how-to-change-an-order-s-route'
          },
          {
            title: 'How to change the status of a route',
            link: 'https://help.onro.io/en/articles/10264661-how-to-change-the-status-of-a-route'
          },
          {
            title: 'How to change the driver of a route',
            link: 'https://help.onro.io/en/articles/10272263-how-to-change-the-driver-of-a-route'
          },
          {
            title: 'How to assign a route to a driver',
            link: 'https://help.onro.io/en/articles/10272317-how-to-assign-a-route-to-a-driver'
          },
          {
            title: 'How to scan orders at the pickup by the driver app',
            link: 'https://help.onro.io/en/articles/10264633-how-to-scan-orders-at-the-pickup-by-the-driver-app'
          },
          {
            title: 'How to inbound scan in hub (At warehouse)',
            link: 'https://help.onro.io/en/articles/10272337-how-to-inbound-scan-in-the-hub-at-warehouse'
          },
          {
            title: 'How to load deliveries',
            link: 'https://help.onro.io/en/articles/10272335-how-to-load-deliveries'
          }
        ],
        EditRoute: [
           {
            title: 'How to add orders to a route',
            link: 'https://help.onro.io/en/articles/10441220-how-to-add-orders-to-a-route'
          },
          {
            title: 'How to complete a route',
            link: 'https://help.onro.io/en/articles/10264619-how-to-complete-a-route'
          },
          {
            title: 'How to change the status of a route',
            link: 'https://help.onro.io/en/articles/10264661-how-to-change-the-status-of-a-route'
          },
          {
            title: 'How to change the driver of a route',
            link: 'https://help.onro.io/en/articles/10272263-how-to-change-the-driver-of-a-route'
          },
          {
            title: 'How to assign a route to a driver',
            link: 'https://help.onro.io/en/articles/10272317-how-to-assign-a-route-to-a-driver'
          }
        ],
        Drivers: [
          {
            title: 'How to monitor/manage drivers',
            link: 'https://help.onro.io/en/articles/10351115-how-to-monitor-manage-drivers'
          }
        ],
        BulkImport: [
          {
            title: 'Bulk Import',
            link: 'https://help.onro.io/en/articles/10259524-bulk-import-orders'
          }
        ],
        NewOrder: [
          {
            title: 'Order types and statuses',
            link: 'https://help.onro.io/en/articles/10264368-order-types-and-statuses'
          },
          {
            title: 'How driver selection works in dispatch algorithm',
            link: 'https://help.onro.io/en/articles/10293802-how-driver-selection-works-in-the-dispatch-algorithm'
          },
          {
            title: 'How dispatching works for scheduled orders',
            link: 'https://help.onro.io/en/articles/10293944-how-dispatching-works-for-scheduled-orders'
          },
          {
            title: 'P&D workflow basics',
            link: 'https://help.onro.io/en/articles/10264423-p-d-workflow-basics'
          },
          {
            title: 'How to disable/enable a service',
            link: 'https://help.onro.io/en/articles/10282553-how-to-disable-enable-a-service'
          },
          {
            title: 'How to assign/offer an order to a driver',
            link: 'https://help.onro.io/en/articles/10259691-how-to-assign-offer-an-order-to-a-driver'
          }
        ],
        PickupDeliveryViewOrder: [
          {
            title: 'How to edit order details',
            link: 'https://help.onro.io/en/articles/10259549-how-to-edit-order-details'
          },
          {
            title: 'Orders shipment label',
            link: 'https://help.onro.io/en/articles/10259832-orders-shipment-label'
          },
          {
            title: 'How to manage failed reasons',
            link: 'https://help.onro.io/en/articles/10351131-how-to-manage-failed-reasons'
          },
          {
            title: 'How to delete an order from a route',
            link: 'https://help.onro.io/en/articles/10272323-how-to-delete-an-order-from-a-route'
          },
          {
            title: 'How to update P&D order status',
            link: 'https://help.onro.io/en/articles/10259538-how-to-update-p-d-order-status'
          },
          {
            title: 'What is POD?',
            link: 'https://help.onro.io/en/articles/10282574-what-is-pod'
          }
        ],
        OndemandViewOrder: [
          {
            title: 'How to dispatch an order urgently',
            link: 'https://help.onro.io/en/articles/10293819-how-to-dispatch-an-order-urgently'
          },
          {
            title: 'The dispatch threshold mechanism of scheduled orders',
            link: 'https://help.onro.io/en/articles/10293949-the-dispatch-threshold-mechanism-of-scheduled-orders'
          },
          {
            title: 'How to edit the "Dispatch At" (time of dispatch) for an order',
            link: 'https://help.onro.io/en/articles/10293816-how-to-edit-the-dispatch-at-time-of-dispatch-for-an-order'
          },
          {
            title: 'ETA & delay management',
            link: 'https://help.onro.io/en/articles/10293937-eta-delay-management'
          },
          {
            title: 'How to edit order details',
            link: 'https://help.onro.io/en/articles/10259549-how-to-edit-order-details'
          },
          {
            title: 'How to assign/offer an order to a driver',
            link: 'https://help.onro.io/en/articles/10259691-how-to-assign-offer-an-order-to-a-driver'
          },
          {
            title: 'Orders shipment label',
            link: 'https://help.onro.io/en/articles/10259832-orders-shipment-label'
          },
          {
            title: 'What is POD?',
            link: 'https://help.onro.io/en/articles/10282574-what-is-pod'
          },
          {
            title: 'How driver selection works in dispatch algorithm',
            link: 'https://help.onro.io/en/articles/10293802-how-driver-selection-works-in-the-dispatch-algorithm'
          },
          {
            title: 'Viewing drivers offered for an order',
            link: 'https://help.onro.io/en/articles/10441477-viewing-drivers-offered-of-an-order'
          }
        ],
        PickupViewOrder: [
          {
            title: 'How to dispatch an order urgently',
            link: 'https://help.onro.io/en/articles/10293819-how-to-dispatch-an-order-urgently'
          },
          {
            title: 'The dispatch threshold mechanism of scheduled orders',
            link: 'https://help.onro.io/en/articles/10293949-the-dispatch-threshold-mechanism-of-scheduled-orders'
          },
          {
            title: 'How to edit the "Dispatch At" (time of dispatch) for an order',
            link: 'https://help.onro.io/en/articles/10293816-how-to-edit-the-dispatch-at-time-of-dispatch-for-an-order'
          },
          {
            title: 'ETA & delay management',
            link: 'https://help.onro.io/en/articles/10293937-eta-delay-management'
          },
          {
            title: 'How to edit order details',
            link: 'https://help.onro.io/en/articles/10259549-how-to-edit-order-details'
          },
          {
            title: 'How to assign/offer an order to a driver',
            link: 'https://help.onro.io/en/articles/10259691-how-to-assign-offer-an-order-to-a-driver'
          },
          {
            title: 'Orders shipment label',
            link: 'https://help.onro.io/en/articles/10259832-orders-shipment-label'
          },
          {
            title: 'What is POD?',
            link: 'https://help.onro.io/en/articles/10282574-what-is-pod'
          },
          {
            title: 'How driver selection works in dispatch algorithm',
            link: 'https://help.onro.io/en/articles/10293802-how-driver-selection-works-in-the-dispatch-algorithm'
          },
          {
            title: 'Viewing drivers offered for an order',
            link: 'https://help.onro.io/en/articles/10441477-viewing-drivers-offered-of-an-order'
          }
        ],
        DeliveryViewOrder: [
          {
            title: 'How to dispatch an order urgently',
            link: 'https://help.onro.io/en/articles/10293819-how-to-dispatch-an-order-urgently'
          },
          {
            title: 'The dispatch threshold mechanism of scheduled orders',
            link: 'https://help.onro.io/en/articles/10293949-the-dispatch-threshold-mechanism-of-scheduled-orders'
          },
          {
            title: 'How to edit the "Dispatch At" (time of dispatch) for an order',
            link: 'https://help.onro.io/en/articles/10293816-how-to-edit-the-dispatch-at-time-of-dispatch-for-an-order'
          },
          {
            title: 'ETA & delay management',
            link: 'https://help.onro.io/en/articles/10293937-eta-delay-management'
          },
          {
            title: 'How to edit order details',
            link: 'https://help.onro.io/en/articles/10259549-how-to-edit-order-details'
          },
          {
            title: 'How to assign/offer an order to a driver',
            link: 'https://help.onro.io/en/articles/10259691-how-to-assign-offer-an-order-to-a-driver'
          },
          {
            title: 'Orders shipment label',
            link: 'https://help.onro.io/en/articles/10259832-orders-shipment-label'
          },
          {
            title: 'What is POD?',
            link: 'https://help.onro.io/en/articles/10282574-what-is-pod'
          },
          {
            title: 'How driver selection works in dispatch algorithm',
            link: 'https://help.onro.io/en/articles/10293802-how-driver-selection-works-in-the-dispatch-algorithm'
          },
          {
            title: 'Viewing drivers offered for an order',
            link: 'https://help.onro.io/en/articles/10441477-viewing-drivers-offered-of-an-order'
          }
        ],
        OndemandEditStatus: [
          {
            title: 'How to assign/offer an order to a driver',
            link: 'https://help.onro.io/en/articles/10259691-how-to-assign-offer-an-order-to-a-driver'
          },
          {
            title: 'How to edit order details',
            link: 'https://help.onro.io/en/articles/10259549-how-to-edit-order-details'
          }
        ],
        OndemandEditPrice: [
          {
            title: 'How to edit order details',
            link: 'https://help.onro.io/en/articles/10259549-how-to-edit-order-details'
          }
        ],
        PickupEditPrice: [
          {
            title: 'How to edit order details',
            link: 'https://help.onro.io/en/articles/10259549-how-to-edit-order-details'
          }
        ],
        DeliveryEditPrice: [
          {
            title: 'How to edit order details',
            link: 'https://help.onro.io/en/articles/10259549-how-to-edit-order-details'
          }
        ],
        PickupDeliveryEditPrice: [
          {
            title: 'How to edit order details',
            link: 'https://help.onro.io/en/articles/10259549-how-to-edit-order-details'
          }
        ],
        PickupEditStatus: [
          {
            title: 'How to assign/offer an order to a driver',
            link: 'https://help.onro.io/en/articles/10259691-how-to-assign-offer-an-order-to-a-driver'
          },
          {
            title: 'How to edit order details',
            link: 'https://help.onro.io/en/articles/10259549-how-to-edit-order-details'
          }
        ],
        DeliveryEditStatus: [
          {
            title: 'How to assign/offer an order to a driver',
            link: 'https://help.onro.io/en/articles/10259691-how-to-assign-offer-an-order-to-a-driver'
          },
          {
            title: 'How to edit order details',
            link: 'https://help.onro.io/en/articles/10259549-how-to-edit-order-details'
          }
        ],
        PickupDeliveryEditStatus: [
          {
            title: 'How to assign/offer an order to a driver',
            link: 'https://help.onro.io/en/articles/10259691-how-to-assign-offer-an-order-to-a-driver'
          },
          {
            title: 'How to edit order details',
            link: 'https://help.onro.io/en/articles/10259549-how-to-edit-order-details'
          }
        ],
        OndemandEditAdresses: [
          {
            title: 'The dispatch threshold mechanism of scheduled orders',
            link: 'https://help.onro.io/en/articles/10293949-the-dispatch-threshold-mechanism-of-scheduled-orders'
          },
          {
            title: 'How to edit order details',
            link: 'https://help.onro.io/en/articles/10259549-how-to-edit-order-details'
          }
        ],
        PickupEditAdresses: [
          {
            title: 'The dispatch threshold mechanism of scheduled orders',
            link: 'https://help.onro.io/en/articles/10293949-the-dispatch-threshold-mechanism-of-scheduled-orders'
          },
          {
            title: 'How to edit order details',
            link: 'https://help.onro.io/en/articles/10259549-how-to-edit-order-details'
          }
        ],
        DeliveryEditAdresses: [
          {
            title: 'The dispatch threshold mechanism of scheduled orders',
            link: 'https://help.onro.io/en/articles/10293949-the-dispatch-threshold-mechanism-of-scheduled-orders'
          },
          {
            title: 'How to edit order details',
            link: 'https://help.onro.io/en/articles/10259549-how-to-edit-order-details'
          }
        ],
        PickupDeliveryEditAdresses: [
          {
            title: 'The dispatch threshold mechanism of scheduled orders',
            link: 'https://help.onro.io/en/articles/10293949-the-dispatch-threshold-mechanism-of-scheduled-orders'
          },
          {
            title: 'How to edit order details',
            link: 'https://help.onro.io/en/articles/10259549-how-to-edit-order-details'
          }
        ]
      }


        // useEffect(() => {
        //   isOpen && document.querySelectorAll( 'a[data-intercom-article]').forEach(link => {
        //     link.addEventListener( 'click', event => {
        //     event.preventDefault();
        //     const articleld = event.target.getAttribute( 'data-intercom-article');
        //     showArticle(articleld)
        //     });
        // });
        // }, [isOpen])


          // useEffect(() => {
          //   try {
          //       if (isOpen) {
          //         const element = document.getElementById('googlemapUniqeId');
          //         setMapZindex(element.style.zIndex)
          //         element.style.zIndex = '7';
          //       } else {
          //         const element = document.getElementById('googlemapUniqeId');
          //         element.style.zIndex = mapZindex;
          //       }
          //   } catch (error) {
              
          //   }
          
          
          //   }, [isOpen]);
      

  const ItemsList = React.useCallback(() => {
    return (
      <div className={styles.itemsConatiner}>
        {articles[where].map((item) => {
          return <a onClick={(e) => {
            e.preventDefault();
            showArticle(getIdFromLink(item.link))
          }} data-intercom-article={getIdFromLink(item.link)} target="_blank" href={item.link} className={itemRowClassName && itemRowClassName}>
            <img src={Book} />  <Typography weight="Body_Middle_Regular" textColor={'extNormal'} text={item.title} className={styles.dropItem} />
          </a>
        })}
      </div>
    )
  }, [where, itemRowClassName]);

  const setHandleIsOpen = React.useCallback((bool) => {

    try {
      if (isBoolean(bool)) {
        if (bool) {

          const element = document.getElementById('googlemapUniqeId');
          setMapZindex(element.style.zIndex)
          element.style.zIndex = '7';
        } else {
          const element = document.getElementById('googlemapUniqeId');
          if (mapZindex) {
            element.style.zIndex = mapZindex;
          }
        }
      }

    } catch (error) {

    }


    setIsOpen(bool)
  }, [mapZindex]);


  if (!intercomData) {
    return <>  </>
  }

  return <>

    <DropDown handleIsOpen={setHandleIsOpen} className={className && className} placement={placement} size='Medium' text={hastext ? t("Learn") : null} icon={Book} ItemsList={ItemsList()} data={articles[where]} noArrowIcon={true} />

  </>

};




const getIdFromLink=(link)=> {
  const text = link

  // ریجکس برای یافتن عدد بعد از متن مشخص‌شده
  const regex = /https:\/\/help\.onro\.io\/en\/articles\/(\d+)/;
  
  // جستجو در متن
  const match = text.match(regex);
  
  if (match) {
    return match[1]
  } else {
    return ""
  }
}



/*

const text = 'https://help.onro.io/en/articles/10293816-how-to-edit-the-dispatch-at-time-of-dispatch-for-an-order';

// ریجکس برای یافتن عدد بعد از متن مشخص‌شده
const regex = /https:\/\/help\.onro\.io\/en\/articles\/(\d+)/;

// جستجو در متن
const match = text.match(regex);

if (match) {
  console.log("Number found:", match[1]); // match[1] شامل عدد استخراج‌شده است
} else {
  console.log("Number not found");
}

*/